module.exports = __webpack_public_path__ + "img/bag.f1f324bd.svg";